import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import BuyAssets from "./BuyAssets";
import { getFormData } from "../../../../helpers";
import OutstandingInvoices from "./OutstandingInvoices";

const AvailaibleCreditNotes = (pageType, viewFormOptions) => {
  const apLiabilityData = useSelector(
    (state) => state?.financeReducer?.apLiabilityData
  );

  function getHtml(pageType) {
    const payments = viewFormOptions?.payments;
    if (pageType === "viewPayment") {
      return (
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th> Account </th>
              <th>Date/Time</th>
              <th>Invoice ID</th>
              <th>Description</th>
              <th>O/S Amount </th>
              <th>Use Now </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{payments?.transaction_date}</td>
              <td>{payments?.transaction_ID}</td>
              <td>{payments?.memo}</td>
              <td>{payments?.payment_purpose?.amount}</td>
              <td>{payments?.payment_purpose?.amount}</td>
            </tr>
          </tbody>
        </table>
      );
    }
    if (pageType === "editPayment") {
      return (
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th> Account </th>
              <th>Date/Time</th>
              <th>Invoice ID</th>
              <th>Description</th>
              <th>O/S Amount </th>
              <th>Use Now </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{payments?.transaction_date}</td>
              <td>{payments?.transaction_ID}</td>
              <td>{payments?.memo}</td>
              <td>{payments?.amount}</td>
              <td>{payments?.amount}</td>
            </tr>
          </tbody>
        </table>
      );
    }

    return (
      <table className="checklist-table remove-space inventory_table">
        <thead>
          <tr>
            <th> Account </th>
            <th>Date/Time</th>
            <th>Invoice ID</th>
            <th>Description</th>
            <th>O/S Amount </th>
            <th>Use Now </th>
          </tr>
        </thead>
        {apLiabilityData?.creditNotes?.map((el, idx) => (
          <tr>
            <td>{el?.merchant?.account_name}</td>
            <td>{el?.transaction_date}</td>
            <td>{el?.credit_note_number}</td>
            <td>{el?.memo}</td>
            <td>{el?.total_price}</td>
            <td>{el?.total_price}</td>
          </tr>
        ))}
      </table>
    );
  }

  return (
    <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
      <h4 className="event-alert w-100 mb-0">Available Credit Notes</h4>
      <div className="row col-12 mx-0">
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th> Account </th>
              <th>Date/Time</th>
              <th>Invoice ID</th>
              <th>Description</th>
              <th>O/S Amount </th>
              <th>Use Now </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};

export default AvailaibleCreditNotes;
